export default __webpack_public_path__ + "static/media/vDot.3dbf8cea.svg";